import { StoragePhotos } from './index'

const subTaskPhotoCollection = () => {

  const findOne = (taskId, subtaskId, photoId) => {
    return StoragePhotos.child(taskId).child(subtaskId).child(photoId).getDownloadURL()
  }

  return Object.freeze({
    findOne
  })
}


const SubTaskPhotos = subTaskPhotoCollection()

export { SubTaskPhotos }
